import { Box, Tab, Tabs } from "@mui/material";
import { SyntheticEvent, useEffect, useState } from "react";
import { Datagrid, List, TextField, UrlField } from "react-admin";
import { useLocation, useNavigate } from "react-router-dom";

const ArchiveList = ({ resource }: { resource: string }) => (
  <List resource={resource}>
    <Datagrid empty={resource === "creditNoteArchive" ? <span>No credit notes yet</span> : undefined}>
      <TextField source="year" />
      <TextField source="id" label="Name" />
      <UrlField source="downloadLink" />
    </Datagrid>
  </List>
);

const InvoiceArchiveList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tabValue = location.pathname.endsWith("/credit-notes") ? 1 : 0;
  const [loadedTabs, setLoadedTabs] = useState<number[]>(tabValue === 1 ? [0, 1] : [0]);

  useEffect(() => {
    if (tabValue === 1) {
      setLoadedTabs((prev) => (prev.includes(1) ? prev : [...prev, 1]));
    }
  }, [tabValue]);

  const handleTabChange = (_: SyntheticEvent, value: number) => {
    if (value === 1) {
      setLoadedTabs((prev) => (prev.includes(1) ? prev : [...prev, 1]));
    }
    navigate(value === 1 ? "/invoices-archive/credit-notes" : "/invoices-archive");
  };

  return (
    <Box>
      <Tabs value={tabValue} onChange={handleTabChange}>
        <Tab label="Invoices" />
        <Tab label="Credit Notes" />
      </Tabs>
      <Box hidden={tabValue !== 0}>
        <ArchiveList resource="invoices-archive" />
      </Box>
      {loadedTabs.includes(1) && (
        <Box hidden={tabValue !== 1}>
          <ArchiveList resource="creditNoteArchive" />
        </Box>
      )}
    </Box>
  );
};

export default InvoiceArchiveList;
